import { makeCommunicationActionCreators } from 'redux-make-communication';

import * as A from '../types/actions';

export const { execute: downloadMediaplan, completed: downloadMediaplanSuccess, failed: downloadMediaplanFail } =
  makeCommunicationActionCreators<A.DownloadMediaplan, A.DownloadMediaplanSuccess, A.DownloadMediaplanFail>(
    'DOWNLOAD_MEDIAPLAN_SERVICE:DOWNLOAD',
    'DOWNLOAD_MEDIAPLAN_SERVICE:DOWNLOAD_SUCCESS',
    'DOWNLOAD_MEDIAPLAN_SERVICE:DOWNLOAD_FAIL',
  );
